import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import type { DocumentDownloadDTO } from "../../dtos/DocumentDownloadDTO";
import { getQueryStringFromParams } from "../utils/paramUtils";
import {
    BASE_API_URL,
    HttpError,
} from "../utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../utils/useHttpGovernmentAgencyHubAppHeaders";

export function useDownloadTaxSubmissionOutcomeMutation() {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async ({
            taxSubmissionId,
            outcomeType,
            taxId,
        }: {
            taxSubmissionId: string;
            outcomeType: string;
            taxId?: string;
        }): Promise<DocumentDownloadDTO> => {
            const queryString = getQueryStringFromParams({
                outcomeType: outcomeType,
                ...(taxId ? { taxId: taxId } : {}),
            });
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/${taxSubmissionId}/outcome?${queryString}`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            const content = new Uint8Array(await response.arrayBuffer());
            const type = response.headers.get("content-type") ?? "";

            return {
                content,
                type,
            };
        },
        meta: {
            errorMessage: t("errors.messages.downloadOutcome"),
        },
    });

    return mutation;
}
